export default __webpack_public_path__ + "static/media/5.1.7a1fcfaa.JPG";